module.exports = "https://static.wmbcdn.com/uniweb/images/66d11953a98d166710ab5333725d49b1.svg";